import React from "react";
import { useCart } from "hooks/useStore";
import Money from "components/money";
import { SHIPPING_PROTECTION_KEY } from "utils/constants";
import { ReactComponent as ShieldCheck } from "svgs/shield-check.svg";
import { ReactComponent as ShieldDenied } from "svgs/shield-denied.svg";
import clsx from "clsx";

const ShippingProtectionToggle = () => {
	const { shippingProtection: { designatedVariant, selected }, addCartItem, removeCartItem, items, updateAttributes, attributes
	} = useCart(["shippingProtection", "addCartItem", "removeCartItem", "items", "updateAttributes", "attributes"]);

	const handleToggle = async () => {
		if (selected) {
			if (!attributes.some(attr => attr.key === SHIPPING_PROTECTION_KEY)) {
				await updateAttributes([{ key: SHIPPING_PROTECTION_KEY, value: "false" }]);
			}
			await removeCartItem(selected.id);
		} else {
			await addCartItem(designatedVariant.gid, 1);
		}
	};

	if (!items?.length || !designatedVariant) return null;

	return (
		<div className="flex items-start rounded-2xl w-full gap-3 justify-between mb-6">
			<div>
				<div className="flex items-center gap-1.5">
					<p className="font-semibold !text-sm md:!text-base text-darkGray flex items-center flex-wrap gap-x-1">
						<span className="shipping-protection-v1">Add Shipping Protection for</span>
						<span className="shipping-protection-v2">Enjoy Peace of Mind for</span>
						<span>
							<Money value={designatedVariant?.price} markets={designatedVariant?.markets} />
						</span>
						{selected ? <ShieldCheck /> : <ShieldDenied />}
					</p>
				</div>
				<p className="block font-normal !text-xxs text-gray-500 !leading-normal">
					Full replacement if your package is lost, damaged, or stolen — no questions asked.
				</p>
			</div>
			<div className="pt-1">
				<button onClick={handleToggle} disabled={!designatedVariant}
					className={clsx(
						"min-w-8 w-8 h-4 flex items-center rounded-full p-0.5 transition-colors duration-300 my-auto shadow-inner",
						selected ? "bg-[#3CB94B]" : "bg-grey"
					)}
				>
					<div
						className={clsx(
							"size-3 rounded-full transform transition-transform duration-300",
							selected ? "translate-x-4 bg-white" : "translate-x-0 bg-white"
						)}
					></div>
				</button>
			</div>
		</div>
	);
};

export default ShippingProtectionToggle;
